import { Component, HostBinding, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { PermissionsService } from '@app/src/app/permissions';

@Component({
  selector: 'mg-dialog-whats-new',
  templateUrl: './WhatsNewDialog.component.html',
  styleUrls: ['./WhatsNewDialog.component.scss'],
})
export class WhatsNewDialog {
  @HostBinding('class.ios-browser')
  readonly iosBrowser = window.MINGA_DEVICE_IOS && window.MINGA_APP_BROWSER;

  constructor(
    private dialogRef: MatDialogRef<WhatsNewDialog>,
    private permissions: PermissionsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.close(true);
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }

  close(save: boolean = true) {
    // Delay on purpose to feel like you hit the correct option
    setTimeout(() => {
      this.dialogRef.close(save);
    }, 300);
  }
}
